// extracted by mini-css-extract-plugin
export default {"root":"mimic___styles_root__Wj3sf","lg":"mimic___styles_lg__UtXRs"};